import TopNDropdownItem from "../TopNDropdownItem/TopNDropdownItem";

export default class TopNRemainingSelectionItem extends TopNDropdownItem {
    getTranslation() {
        return {
            key: "si.table-actions-panel.options.top-n.remaining-quota",
            replacements: {
                n: this.formatValue(),
            },
        };
    }
}
